<template>
  <div class="circles__container" ref="container">
    <div class="circles__header">
      <div class="circles__header-item">
        <br /><span class="f-ui-2">{{ title }}</span>
      </div>
      <div
        class="circles__header-item"
        :style="{ width: `${useCircleSize / 2}px` }"
      >
        <br />2021
      </div>
      <div
        class="circles__header-item"
        :style="{ width: `${useCircleSize / 2}px` }"
      >
        <span class="color-STEPS">STEPS</span><br />2050
      </div>
      <div
        class="circles__header-item"
        :style="{ width: `${useCircleSize / 2}px` }"
      />
      <div
        class="circles__header-item"
        :style="{ width: `${useCircleSize / 2}px` }"
      >
        <span class="color-APS">APS</span><br />2050
      </div>
      <div
        class="circles__header-item"
        :style="{ width: `${useCircleSize / 2}px` }"
      />
      <div
        class="circles__header-item"
        :style="{ width: `${useCircleSize / 2}px` }"
      >
        <span class="color-NZE">NZE</span><br />2050
      </div>
    </div>
    <div class="circles">
      <p class="f-ui-2-bold circles__label">
        <strong>{{ label }}</strong>
      </p>
      <CircleCompare
        :left="historic"
        :right="STEPS"
        right-color="STEPS"
        :units="units"
        :max="max"
        :circle-size="useCircleSize"
      />
      <CircleCompare
        :left="historic"
        :right="APS"
        right-color="APS"
        hide-left-amount
        :max="max"
        :circle-size="useCircleSize"
      />
      <CircleCompare
        :left="historic"
        :right="NZE"
        right-color="NZE"
        hide-left-amount
        :max="max"
        :circle-size="useCircleSize"
      />
    </div>
  </div>
</template>

<script>
import CircleCompare from "./CircleCompare.vue";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    historic: {
      type: Number,
      required: true,
    },
    STEPS: {
      type: Number,
      required: true,
    },
    APS: {
      type: Number,
      required: true,
    },
    NZE: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    units: {
      type: String,
      default: "",
    },
    circleSize: {
      type: Number,
      default: 150,
    },
  },
  components: { CircleCompare },
  data() {
    return {
      useCircleSize: this.circleSize,
    };
  },
  mounted() {
    const maxSize = (this.$refs.container.offsetWidth - 120) / 3;
    this.useCircleSize = maxSize > this.circleSize ? this.circleSize : maxSize;
  },
};
</script>

<style scoped>
.circles__container {
  position: relative;
  width: 100%;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.circles {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  border-top: 2px solid black;
}
.circles__header {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  line-height: 1;
}
.circles__header-item {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  height: 40px;
  margin: 0px;
  padding-left: 4px;
  padding-bottom: 4px;
  padding-top: 2px;
}
.circles__header-item:nth-child(even) {
  text-align: right;
  padding-right: 4px;
  border-right: 1px solid black;
}
.circles__header-item:first-child {
  flex: 1 0 120px;
  min-width: 120px;
}
.circles__label {
  flex: 1 0 120px;
  min-width: 120px;
  font-size: 16px;
}
/* Responsive */
@media screen and (max-width: 1024px) {
  .circles__label,
  .circles__header-item {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 729px) {
  .circles__container {
    width: 100%;
  }
  .circles__label {
    font-size: 14px;
  }
  .circles__header-item {
    font-size: 12px;
    white-space: nowrap;
  }
  .circles,
  .circles__header {
    background: #fff;
  }
  .slide-fade-enter-active.circles__container .circles,
  .slide-fade-enter-active.circles__container .circles__header,
  .slide-fade-leave-active.circles__container .circles,
  .slide-fade-leave-active.circles__container .circles__header {
    background: transparent;
  }
}
</style>
